module.exports = __webpack_public_path__ + "static/img/about-certificate-09.74a0853.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/about-certificate-09.jpg
// module id = o3yh
// module chunks = 1